import { render, staticRenderFns } from "./IndexService.vue?vue&type=template&id=3c01e03c&scoped=true"
import script from "./IndexService.vue?vue&type=script&lang=js"
export * from "./IndexService.vue?vue&type=script&lang=js"
import style0 from "./IndexService.vue?vue&type=style&index=0&id=3c01e03c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c01e03c",
  null
  
)

export default component.exports